<script>
import { required } from 'vuelidate/lib/validators'
import AddEdit from './addedit'
import { Auth } from 'aws-amplify'

import axios from 'axios'

export default {
  components: { AddEdit },
	props: {
    id: {
      type: String,
      default: 'recommendations'
    },
		url: {
			type: String,
			default: '/recommendations/list?withid=yes&include=incident.incident,incident.assets&limit=100',
		},
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number,
      default: 0
    },
    showDatetime: {
      type: Boolean,
      default: true
    },
    action: {
      type: Boolean,
      default: true
    },
	},
	data() {
		return {
		  username: '',
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Indicators View',
					active: true,
				},
			],
      note: '',
      recommendation: {
        title: null,
        body: null,
        type: null,
        priority: null,
        tags: [],
        notes: []
      },
      tmpStatus: '',
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			incidents: [],
			recommendationData: [],
			totalRows: 0,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			filter: '',
			filterOn: [],
			sortDesc: true,
      sortBy: 'incident_id',
			fields: [
				{ key: 'title', label: 'Title', sortable: true },
				{ key: 'body', label: 'Body', sortable: true },
        { key: 'priority', label: 'Priority', sortable: true },
        { key: 'type', label: 'Type', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
				{ key: 'tags', label: 'Tags', sortable: true },
				{ key: 'created', sortable: true },
        (this.action === true) ? { key: 'action', sortable: false } : {}
			],
			isBusy: true,
      optionsStatus: [
        { value: 'Initial', text: 'Initial' },
        { value: 'Under Review', text: 'Under Review' },
        { value: 'More Information Needed', text: 'More Information Needed' },
        { value: 'Previously Known', text: 'Previously Known' },
        { value: 'Implementing', text: 'Implementing' },
        { value: 'Ignored', text: 'Ignored' },
        { value: 'Disagree', text: 'Disagree' }
      ],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	computed: {
		rows() {
			return this.totalRows
		}

  },
  async beforeCreate() {
    let user = await Auth.currentUserInfo()
        .then(user => {
          return user;
        })
        .catch(ex => {
          console.log(ex);
          return
        });

    if (user !== undefined) {
      this.username = user.attributes.email
    }
  },
	mounted () {
    const that = this
    that.$root.$on('recommendationCreatedOk', () => {
      that.loadData()
    })
    that.end += 18000000
		that.loadData()
	},
	methods: {
    loadData (src='') {
      let that = this
      that.isBusy = true
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      let countURL =  (src.length < 1) ? `${baseURL}${that.url}&count=yes` : `${baseURL}${that.url}&rawsearch=${src}&count=yes`
      countURL = (that.start > 0 && that.end > 0) ?
          `${countURL}&start=${that.start}&end=${that.end}` :
          `${countURL}`
      axios.get(countURL)
          .then((response) => {
            that.totalRows = parseInt(response.data)
          })
          .catch(function (error) {
            return
          })
      let dataURL = (src.length < 1 ) ?
          `${baseURL}${that.url}&page=${that.currentPage}&page_size=${that.perPage}&limit=${that.perPage}` :
          `${baseURL}${that.url}&page=${that.currentPage}&page_size=${that.perPage}&limit=${that.perPage}&rawsearch=${src}`
      dataURL = (that.start > 0 && that.end > 0) ?
          `${dataURL}&start=${that.start}&end=${that.end}` :
          `${dataURL}`
      axios.get(dataURL).then((response) => {
        if (response.status === 200) {
          that.recommendationData = response.data.map(function(entry){
            return {
              id: entry["_id"]["$oid"],
              title: entry.title,
              body: entry.body,
              priority: entry.priority,
              status: entry.status,
              type: entry.type,
              tags: entry.tags,
              notes: entry.notes || [],
              created:  new Date(entry.created['$date']).toLocaleString(),
            }
          })
        }
        that.isBusy = false
        that.$emit('finished', that.id, true, `Recommendation Data: ${that.recommendationData.length}`)
      })
      .catch(function (error) {
        that.$emit('finished', that.id, false, error.response)
      })
    },
    newNote(data) {
      this.note = ''
      this.recommendation = data
      this.tmpStatus = this.recommendation.status
      this.$refs['modal-new-note'].show()
    },
    createNote() {
      console.log('create note')
      const that = this
      let note = {}
      const now = new Date(Date.now())
      note['text'] = that.note
      note['created'] = now
      note['by'] = that.username
      note['status'] = that.recommendation.status
      that.recommendation.notes.push(note)
      that.recommendation.created = new Date(that.recommendation.created)
      that.recommendation.updated = now
      console.log('recommendation', that.recommendation)
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      axios.post(`${baseURL}/recommendations/update`, that.recommendation).then(response => {
        that.loadData()
      }).catch(e => {
        console.log(e);
      });
    },
    cancelNote() {
      this.recommendation.status = this.tmpStatus
    },
    deleteRecommendation(data) {
      const that = this
      const confirmRes = confirm("Are you sure ?");
      if (confirmRes === false) {
        return
      }
      that.recommendation = data
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      axios.post(`${baseURL}/recommendations/delete`, that.recommendation).then(response => {
        if (response.status === 200) {
          that.loadData()
        }
      }).catch(e => {
        console.log(e);
      });
    },
    day(recDate) {
      console.log(new Date(recDate).getDate())
      return new Date(recDate).getDate()
    },
    month(recDate) {
      const ndate = new Date(recDate)
      const month = ndate.getMonth()
      const year = ndate.getFullYear()
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      return monthNames[month]
    },
    year(recDate) {
      const ndate = new Date(recDate)
      const year = ndate.getFullYear()
      return year
    }
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.loadData(this.filter)
      }
    },
    perPage: {
      handler: function(value) {
        this.loadData(this.filter)
      }
    },
  }
}
</script>

<template>
  <div>
  <div class="row mt-3">
    <div class="col-lg-12">
      <div class="left-timeline pl-4">
        <ul class="list-unstyled events">
          <li v-for="(recommendation, index) in recommendationData" class="event-list" v-bind:key="index">
            <div>
              <div class="media">
                <div class="event-date text-center mr-4">
                  <div class="avatar-sm rounded-circle bg-soft-primary">
                      <span class="font-size-16 avatar-title text-primary font-weight-semibold">
                        {{ day(recommendation.created) }}
                      </span>
                  </div>
                  <p class="mt-2">{{ month(recommendation.created) }}</p>
                  <p style="margin-top: -20px">{{ year(recommendation.created) }}</p>

                </div>
                <div class="media-body">
                  <div class="card d-inline-block " style="width:100%">
                    <div class="card-body">
                      <h5 class="mt-0">{{ recommendation.title }}</h5>
                      <p class="text-muted">
                        {{ recommendation.body }}
                      </p>
                      <div class="row align-items-center">
                        <div class="col-sm-auto">
                          <ul class="list-inline mb-0">
                            <li class="list-inline-item pr-2">
                              <span class="text-primary">
                                Priority:
                              </span>
                              <span :class="{
                                'text-danger': `${recommendation.priority}` === 'Critical',
                                'text-warning': `${recommendation.priority}` === 'Important',
                                'text-success': `${recommendation.priority}` === 'Good Practice',
                                'text-info': `${recommendation.priority}` === 'Useful',
                                'text-dark': `${recommendation.priority}` === 'Informational',
                              }">
                                {{ recommendation.priority }}
                              </span>
                            </li>
                            <li class="list-inline-item pr-2">
                              <span class="text-primary">Status: </span>
                              <span>{{ recommendation.status }}</span>
                            </li>
                            <li class="list-inline-item pr-2">
                              <span class="text-primary">Type: </span>
                              <span>{{ recommendation.type }}</span>
                            </li>
                            <li class="list-inline-item pr-2">
                              <span class="text-primary">
                                Tags:
                              </span>
                              <b-badge v-for="(tag, ind) in recommendation.tags" class="bg-soft-dark text-dark ml-1" v-bind:key="ind">
                                {{ tag }}
                              </b-badge>
                            </li>
                          </ul>
                        </div>
                      </div>

<!--                      <b-badge class="bg-soft-dark text-dark">-->
<!--                        {{ recommendation.type }}-->
<!--                      </b-badge>-->

<!--                      <b-badge-->
<!--                          class="ml-1"-->
<!--                          :class="{-->
<!--                          'bg-soft-danger text-danger':-->
<!--                            `${recommendation.priority}` === 'Critical',-->
<!--                          'bg-soft-warning text-warning':-->
<!--                            `${recommendation.priority}` === 'Important',-->
<!--                          'bg-soft-success text-success':-->
<!--                            `${recommendation.priority}` === 'Good Practice',-->
<!--                          'bg-soft-info text-info':-->
<!--                            `${recommendation.priority}` === 'Useful',-->
<!--                          'bg-soft-dark text-dark':-->
<!--                            `${recommendation.priority}` === 'Informational',-->
<!--                        }"-->
<!--                      >{{ recommendation.priority }}-->
<!--                      </b-badge>-->

<!--                      <b-badge class="bg-soft-dark text-dark ml-1">-->
<!--                        {{ recommendation.status }}-->
<!--                      </b-badge>-->
<!--                      &nbsp;-->
                      <div class="ml-1 float-right">
                        <b-dropdown right variant="white" class="align-self-center" toggle-class="p-0">
                          <template v-slot:button-content>
                            <feather type="chevron-down" class="align-middle" style="height:12px !important;width:20px !important;"></feather>
                          </template>
                          <b-dropdown-item @click="newNote(recommendation)" class="notify-item">
                            <feather
                                type="edit"
                                class="icon-dual icon-xs mr-2 align-middle"
                            ></feather>
                            <span>Create Note</span>
                          </b-dropdown-item>
                        </b-dropdown>
                      </div>
                    </div>

                    <div v-for="(note, nindex) in recommendation.notes" v-bind:key="nindex">
                      <div class="card-body border-top">
                        <span style="font-size: 0.95em; color:#808080">
                          {{ note.text }}
                        </span>
                      </div>
                      <div class="card-body">
                        <div class="row align-items-center">
                          <div class="col-sm-auto">
                            <ul class="list-inline mb-0">
                              <li class="list-inline-item pr-2">
                                <a
                                    :id="`by-tooltip-${note.by}-${nindex}`"
                                    href="javascript: void(0)"
                                    class="text-muted d-inline-block"
                                >
                                  <b-tooltip
                                      :target="`by-tooltip-${note.by}-${nindex}`"
                                      triggers="hover"
                                      placement="top"
                                  >Note created by</b-tooltip
                                  >
                                  <span class="text-primary">
                                    <i class="uil uil-user mr-1"></i>
                                  </span>
                                  {{ note.by }}
                                </a>
                              </li>
                              <li class="list-inline-item pr-2">
                                <a
                                    :id="`date-tooltip-${note.created}-${nindex}`"
                                    href="javascript: void(0)"
                                    class="text-muted d-inline-block"
                                >
                                  <b-tooltip
                                      :target="`date-tooltip-${note.created}-${nindex}`"
                                      triggers="hover"
                                      placement="top"
                                  >Creation date</b-tooltip
                                  >
                                  <span class="text-primary">
                                    <i class="uil uil-calender mr-1"></i>
                                  </span>
                                  {{ note.created.toLocaleString() }}
                                </a>
                              </li>
                              <li class="list-inline-item pr-2">
                                <a
                                    :id="`status-tooltip-${note.status}-${nindex}`"
                                    href="javascript: void(0)"
                                    class="text-muted d-inline-block"
                                >
                                  <b-tooltip
                                      :target="`status-tooltip-${note.status}-${nindex}`"
                                      triggers="hover"
                                      placement="top"
                                  >Incident status after this note creation</b-tooltip
                                  >
                                  <span class="text-primary">
                                   <i class="uil uil-calender mr-1"></i>
                                  </span>
                                  {{ note.status }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
    <b-modal
        ref="modal-new-note"
        size="xl"
        title="Create a New Note for this Recommendation"
        :centered=true
        :no-fade=true
        @ok="createNote"
        @cancel="cancelNote"
    >
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-xl-12 col-sm-12">
                  <div class="form-group mt-3 mt-sm-0">
                    <label for="default">Note text</label>
                    <b-form-textarea
                        id="textarea-1"
                        v-model="note"
                        placeholder="Type note text here..."
                        rows="4"
                        max-rows="8"
                    ></b-form-textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12 col-sm-12">
                  <div class="form-group mt-3 mt-sm-0">
                    <label for="default">Change Incident Status</label>
                    <b-form-select
                        id="select-type"
                        v-model="recommendation.status"
                        :options="optionsStatus"
                    ></b-form-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
  .critical {
    color: #DC001E
  }
  .important {
    color: orange
  }
  .recommended {
    color: #d0d020
  }
  .useful {
    color: #01AD00
  }
  .informational {
    color: #5d8aff
  }
</style>